import { AuthContext, AuthProvider } from 'context/AuthContext';
import { EditorPreviewProvider } from 'context/EditorPreviewContext';
import { useContext } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import AppRoutes from 'routes/AppRoutes';
import { MainToastContainer } from 'components/Toaster';
import { PdfJobProvider } from 'context/PdfJobContext';
import JobTracker from 'components/Pdf/JobTracker';
import QuizPdfRecovery from 'components/Pdf/QuizPdfRecovery';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function AppShell() {
  const authContext = useContext(AuthContext);

  const content = (
    <EditorPreviewProvider>
      <AppRoutes />
      {authContext.isAuthenticated() && <JobTracker />}
    </EditorPreviewProvider>
  );

  if (!authContext.isAuthenticated()) return content;

  return (
    <PdfJobProvider>
      <QuizPdfRecovery />
      {content}
    </PdfJobProvider>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <MainToastContainer />

      <Router>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
